import { Crop, getCrops } from '@next/arable-lib/crop';
import { createSelector } from '@ngrx/store';

export const getCropsMap = createSelector(getCrops, (crops: Crop[]) =>
  crops.reduce<{ [key: string]: string }>((acc, curr) => {
    acc[curr.id.toString()] = curr.name;
    return acc;
  }, {}),
);
